import React from 'react';

export interface FilterTabOption<T extends string | number = string> {
  label: string;
  value: T;
}

interface FilterTabsProps<T extends string | number = string> {
  options: FilterTabOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
  size?: 'sm' | 'md';
}

export function FilterTabs<T extends string | number = string>({
  options,
  value,
  onChange,
  className = '',
  size = 'sm',
}: FilterTabsProps<T>) {
  const sizeClasses = size === 'md' ? 'px-6 py-2.5 text-sm' : 'px-6 py-2 text-sm';
  return (
    <div className={['flex flex-wrap md:flex-nowrap md:overflow-x-auto gap-1.5', className].filter(Boolean).join(' ')}>
      {options.map(({label, value: v}) => (
        <button
          key={String(v)}
          onClick={() => onChange(v)}
          className={`${sizeClasses} font-medium rounded-full transition-all duration-200 ${
            value === v ? 'bg-blue-500 text-white shadow-md' : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
          }`}>
          {label}
        </button>
      ))}
    </div>
  );
}
